/* eslint-disable no-useless-escape */
import React from 'react';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import PopupLoader from 'components/common/PopupLoader';
import { addAlert } from 'store/actions/alert/alerts';
import { authGetRequest, authPatchRequestWithParam } from 'helpers/apiRequests';
import { fromUpperCaseToUnderScore } from 'helpers/variablesNamesFit';

import ComponentUserRender from 'components/user/admin/users/ComponentUserRender';

const EditUsers = props => {
  const { user, goBackToMainScreen } = props;
  const dispatch = useDispatch();
  const [organizations, setOrganizations] = React.useState([]);
  const [userGroups, setUserGroups] = React.useState([]);

  const useString = () => {
    const language = useSelector(state => state.language);
    return language;
  };
  const [subtitles] = React.useState(useString().adminZone.user);
  const [userPermissionNames] = React.useState(useString().userPermissionList);
  const [subtitlesErrors] = React.useState(useString().errors);

  const [alertsSubtitles] = React.useState(useString().alerts);
  const [seeableLoader, setSeeableLoader] = React.useState(false);

  const [showErrors, setShowErrors] = React.useState(false);
  const [groupArray, setGroupArray] = React.useState([...user.groups]);
  const [values, setValues] = React.useState({
    uid: user.uid,
    firstName: user.firstName,
    lastName: user.lastName,
    username: user.username,
    phone: user.phone,
    email: user.email,
    city: user.address ? user.address.city : '',
    street: user.address ? user.address.street : '',
    number: user.address ? user.address.number : '',
    organization: user.organization,
  });

  const handleApiRequests = () => {
    authGetRequest('organizations').then(result => {
      if (result.status === 200) setOrganizations(result.data);
      else {
        dispatch(
          addAlert({
            title: alertsSubtitles[result.data.code].title_,
            desc: alertsSubtitles[result.data.code].desc_,
            type: 'error',
          })
        );
      }
    });
    authGetRequest('permissionsList').then(result => {
      if (result.status === 200) setUserGroups(result.data);
      else {
        dispatch(
          addAlert({
            title: alertsSubtitles[result.data.code].title_,
            desc: alertsSubtitles[result.data.code].desc_,
            type: 'error',
          })
        );
      }
    });
  };

  React.useEffect(handleApiRequests, []);

  const handleChange = event => {
    const { target } = event;
    const { name, value } = target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  const validateAlphanumeric = (value, keyValue) => {
    if (!value.match(/^[0-9a-zA-Z]+$/)) {
      setValues({ ...values, [keyValue]: '' });
      return true;
    }
  };

  const validatePhone = value => {
    if (!value.match(/^(\+|00)?[1-9][0-9 \-\(\)\.]{7,32}$/)) {
      setValues({ ...values, phone: '' });
      return true;
    }
  };

  const onGroupChange = event => {
    const { value, checked } = event.target;
    if (checked) {
      setGroupArray([...groupArray, parseInt(value)]);
    } else {
      const index = groupArray.indexOf(parseInt(value));
      setGroupArray(groupArray.filter((_, i) => i !== index));
    }
  };

  const isDataValid = () => {
    let isValid = true;
    Object.keys(values).forEach(key => {
      if (values[key] === '') isValid = false;
    });
    if (validateAlphanumeric(values.username, 'username')) isValid = false;
    if (validatePhone(values.phone)) isValid = false;
    if (!groupArray.length) isValid = false;
    if (!isValid) return setShowErrors(true);
    return isValid;
  };

  const getSelectedOrganizationName = () => {
    if (organizations.length && values.organization !== '')
      return organizations.find(x => x.uid === values.organization).uid;

    return 'none';
  };

  const isGroupChecked = id => {
    if (groupArray.length && id !== undefined) {
      return groupArray.indexOf(id) >= 0;
    }
    return false;
  };

  const add = async () => {
    if (!isDataValid()) return;

    setSeeableLoader(true);
    const data = { ...values };
    data.address = {
      city: values.city,
      street: values.street,
      number: values.number,
    };
    delete data.city;
    delete data.street;
    delete data.number;
    delete data.rePassword;

    const groupData = { groups: groupArray };

    const parsedData = fromUpperCaseToUnderScore(data);

    const result = await authPatchRequestWithParam(
      'editUserByAdmin',
      values.uid,
      parsedData
    );
    const permissionResult = await authPatchRequestWithParam(
      'permissions',
      values.uid,
      groupData
    );
    if (result.status === 200 && permissionResult.status === 200) {
      dispatch(
        addAlert({
          title: alertsSubtitles.addDataSuccess.title_,
          desc: alertsSubtitles.addDataSuccess.desc_,
          type: 'success',
        })
      );
      setSeeableLoader(false);
      goBackToMainScreen();
    } else
      dispatch(
        addAlert({
          title: alertsSubtitles[result.data.code].title_,
          desc: alertsSubtitles[result.data.code].desc_,
          type: 'error',
        })
      );
    setSeeableLoader(false);
  };
  return (
    <>
      {seeableLoader && <PopupLoader />}
      <ComponentUserRender
        add={add}
        values={values}
        handleChange={handleChange}
        onGroupChange={onGroupChange}
        getSelectedOrganizationName={getSelectedOrganizationName}
        isGroupChecked={isGroupChecked}
        showErrors={showErrors}
        organizations={organizations}
        subtitles={subtitles}
        user={user}
        userGroups={userGroups}
        groupArray={groupArray}
        goBackToMainScreen={goBackToMainScreen}
        subtitlesErrors={subtitlesErrors}
        userPermissionNames={userPermissionNames}
      />
    </>
  );
};

EditUsers.propTypes = {
  user: PropTypes.object.isRequired,
  goBackToMainScreen: PropTypes.func.isRequired,
};

export default EditUsers;
